import SavingsIcon from '@mui/icons-material/Savings';
import { useIntl } from 'react-intl';

import { convertDollarsToCents, formatPrice } from '@ocx-app/lib/formatters/formatPrice';

import { LoyaltyItemContent } from '../loyalty-item-content';
import { messages } from '../../receipt-loyalty-card.messages';

type DiscountItemProps = {
  savedAmount: number;
  appliedOffersNumber: number;
};

export const DiscountItem = (props: DiscountItemProps) => {
  const { savedAmount, appliedOffersNumber } = props;
  const intl = useIntl();

  return (
    <LoyaltyItemContent
      icon={<SavingsIcon />}
      title={intl.formatMessage(messages['receipt:loyalty-card:saved'])}
      value={formatPrice(convertDollarsToCents(savedAmount))}
      appliedOffersNumber={appliedOffersNumber}
    />
  );
};
